module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('h2', {
    staticClass: "chapterTitle"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/content#ch_02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("YEAR EARLIER")]), _c('br'), _vm._v(" C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AMBRIDGE")]), _vm._v(", M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ASSACHUSETTS")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("W")])]), _vm._v("ill Piper arrived early to get a drink on board before the others arrived. The crowded restaurant, off Harvard Square, was called OM, and Will shrugged his heavy shoulders at the trendy eclectic Asian ambience. It wasn’t his kind of place but the lounge had a bar and the bartender had ice cubes and scotch so it met his minimum requirements. He looked askance at the artistically rough-cut stonework wall behind the bar, the bright flat-screen installations of video art and the neon-blue lights, and asked himself, What am I doing here?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As early as a month ago, the probability of him attending his twenty-fifth college reunion was zero, and yet here he was, back at Harvard with hundreds of forty-seven-and forty-eight-year-olds, wondering where the prime cut of their lives had gone. Jim Zeckendorf, good lawyer that he was, relentlessly cajoled and hounded him and the others via e-mail until they all acquiesced. Not that he signed up for the full monty. Nobody was going to make him march with the class of 1983 into Tercentenary Theater. But he agreed to drive up from New York to have dinner with his roommates, stay over at Jim’s house in Weston, and head back in the morning. He’d be damned if he was going to blow more than two vacation days on ghosts from the past.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Will’s glass was empty before the bartender was done fill"), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("ing the next order. He rattled the ice to get the guy’s attention and attracted a woman instead. She was standing behind him, waving a twenty at the bartender, a splendid-looking brunette in her thirties. He smelled her spiced fragrance before she leaned over his broad back and asked, “When you get him, can you get me a chard?”")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("He half turned, and her cashmere bosom was at eye level, as was the twenty dollar bill, dangling from slender fingers. He addressed her breasts, “I’ll get it for you,” then rotated his neck to see a pretty face with mauve eye shadow and red glossy lips, just the way he liked them. He picked up strong availability vibes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She withdrew the money with a lilting, “Thanks,” and inserted herself into the tight space he made by sliding his stool a couple of inches.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In a few minutes Will felt a tap on his shoulder and heard, “Told you we’d find him at the bar!” Zeckendorf had a big grin on his smooth, almost feminine face. He still had enough hair to pull off a curly Jewfro, and Will had a flashback to his first day in Harvard Yard in 1979, a big blond oaf from the Florida panhandle, flopping around like a bonita on the deck of a boat meeting a skinny bushy-haired kid with the self-assured swagger of a local who was bred to wear crimson. Zeckendorf’s wife was at his side, or at least Will assumed that the surprisingly matronly woman with thick haunches was the same twiglike bride he last saw at their wedding in 1988.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("The Zeckendorfs had Alex Dinnerstein and his girlfriend in tow. Alex had a tight diminutive body and a flawless tan that made him seem the youngest of the roomies, and he flaunted his fitness and panache with an expensive European-cut suit and a fancy pocket handkerchief, white and bright like his teeth. His gelled hair was as straight and ")]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("black as it was freshman year and Will pegged him as a dyer—to each his own. Dr. Dinnerstein had to keep young for the sweet thing on his arm, a model at least twenty years their junior, a long-legged beauty with a very special figure who almost made Will forget his new friend, who had been left awkwardly sipping at her glass of wine.")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Zeckendorf noticed the lady’s discomfort. “Will, are you going to introduce us?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Will smiled sheepishly and muttered, “We haven’t gotten that far,” eliciting a knowing snort from Alex.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The woman said, “I’m Gillian. I hope you all enjoy your reunion.” She started moving away, and Will wordlessly pressed one of his cards into her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She glanced at it and the flicker across her face revealed surprise: "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("SPECIAL AGENT WILL PIPER, FEDERAL BUREAU OF INVESTIGATION.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When she was gone, Alex made a show of patting Will down and hamming, “Probably never met a Harvard man packing heat, eh, buddy? Is that a Beretta in your pocket or are you happy to see me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Fuck off, Alex. Good to see you too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Zeckendorf herded them up the stairs toward the restaurant then realized they were one short. “Anyone seen Shackleton?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You sure he’s still alive?” Alex asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Circumstantial evidence,” Zeckendorf answered. “E-mails.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He won’t show. He hated us,” Alex claimed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He hated you,” Will said. “You’re the one who duct-taped him to his fucking bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You were there too if I recall,” Alex sniggered.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("The restaurant was buzzing with affluent chatter, a mood-lit museum space with Nepalese statuary and a Buddha-em")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("bedded wall. Their table overlooking Winthrop Street was waiting but not empty. There was a solitary man at one end, nervously fingering his napkin.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Hey, look who’s here!” Zeckendorf called out.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mark Shackleton looked up as if he’d been dreading the moment. His small closely spaced eyes, partially concealed by the bill of a Lakers cap, darted from side to side, scanning them. Will recognized Mark instantly, even though it had been more like twenty-eight years, since he pretty much lost touch with him the minute freshman year was over. The same zero-fat face that made his head look like a deep-socketed, high-domed meatless skull, the same tension-banded lips and sharp nose. Mark hadn’t looked like a teenager even when he was one; he just grew into his natural middle-aged state.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The four roommates were an odd-duck sort of grouping: Will, the easygoing jock from Florida; Jim, the fast-talking prep-school kid from Brookline; Alex, the sex-mad premed from Wisconsin; and Mark, the reclusive computer nerd, from nearby Lexington. They had been squeezed into a quad in Holworthy at the northern pole of leafy Harvard Yard, two tiny bedrooms with bunks and a common room with half-decent furniture, thanks to Zeckendorf’s rich parents. Will was the last to arrive at the dorm that September, as he’d been ensconced with the football team for preseason training. By then Alex and Jim had paired up, and when he lugged his duffel bag over the threshold, the two of them snorted and pointed to the other bedroom, where he found Mark stiffly planted on the lower bunk, claiming it, afraid to move.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hey, how’re you doin’?” Will had asked the kid while sprouting a big southern smile on his chiseled face. “How much ya weigh there, Mark?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“One forty,” Mark answered suspiciously as he struggled to make eye contact with the boy towering over him.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Well, I register at two twenty-five in my shorts. You sure you want my heavy ass a couple of feet over your head on that rickety old bunk bed?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mark had sighed deeply, wordlessly ceded his claim, and the pecking order was thus permanently established.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They fell into the random chaotic conversation of reunionites, excavating memories, laughing at embarrassments, dredging up indiscretions and foibles. The two women were their audience, their excuse for exposition and elaboration. Zeckendorf and Alex, who had remained fast friends, acted as emcees, ping-ponging the banter like a couple of stand-ups extracting laughs at a comedy club. Will wasn’t as fast with a quip but his quiet, slowly spoken recollections of their dysfunctional year had them rapt. Only Mark was quiet, politely smiling when they laughed, drinking his beer and picking at his Asian fusion food. Zeckendorf’s wife had been tasked by her husband to snap pictures, and she obliged by circling the table, posing them and flashing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Freshman roommate groups are like an unstable chemical compound. As soon as the environment changes, the bonds break and the molecules fly apart. In sophomore year Will went to Adams House to room with other football players, Zeckendorf and Alex kept together and went to Leverett House, and Mark got a single at Currier. Will occasionally saw Zeckendorf in a government class, but they all basically disappeared into their own worlds. After graduation, Zeckendorf and Alex stayed in Boston and the two of them reached out to Will from time to time, usually triggered by reading about him in the papers or catching him on TV. None of them spent a moment thinking about Mark. He faded away, and had it not been for Zeckendorf’s sense of occasion and Mark’s inclusion of his gmail address in the reunion book, he would have remained a piece of the past to them.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Alex was loudly going on about some freshman escapade ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("involving twins from Lesley College, a night that allegedly set him on a lifelong path of gynecology, when his date shifted the conversation to Will. Alex’s increasingly tipsy clowning was wearing on her and she kept glancing at the large sandy-haired man who was steadily drinking scotch across from her, seemingly without inebriation. “So how did you get involved with the FBI?” the model asked him before Alex could launch into another tale about himself.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Well, I wasn’t good enough at football to go pro.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No, really.” She seemed genuinely interested.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t know,” Will answered softly. “I didn’t have a whole lot of direction after I graduated. My buddies here knew what they wanted: Alex and med school, Zeck and law school, Mark had grad school at MIT, right?” Mark nodded. “I spent a few years knocking around back in Florida, doing some teaching and coaching and then a position opened up in a county sheriff’s office down there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Your father was in law enforcement,” Zeckendorf recalled.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Deputy sheriff in Panama City.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Is he still alive?” Zeckendorf’s wife asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No, he passed a long time ago.” He had a swallow of scotch. “I guess it was in my blood and the path of least resistance and all that so I went with it. After a while it made the chief uncomfortable that he had a smart-ass Harvard dude as a deputy and he had me apply to Quantico to get me the hell out of there. That was it, and in the blink of an eye I’m staring retirement in the face.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“When do you hit your twenty?” Zeckendorf asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Little over two years.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Then what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Other than fishing, I don’t have a clue.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Alex was busily pouring another bottle of wine. “Do you ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("have any idea how famous this asshole is?” he asked his date.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("She bit. “No, how famous are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Bullshit!” Alex exclaimed. “Our man here is like the most successful serial killer profiler in the history of the FBI!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No, no, that’s certainly not true,” Will strongly demurred.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“How many have you caught over the years?” Zeckendorf asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t know. A few, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“A few! That’s like saying I’ve done a few pelvic exams,” Alex exclaimed. “They say you’re the man—infallible.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I think you’re referring to the Pope.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“C’mon, I read somewhere you can psychoanalyze someone in under a half a minute.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t need that long to figure you out, buddy, but seriously, you shouldn’t believe everything you read.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Alex nudged his date. “Take my word for it—watch out for this guy. He’s a phenom.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Will was anxious to change the subject. His career had taken a few nonsuperlative turns, and he didn’t feel much like dwelling on past glories. “I guess we’ve all done pretty well considering our shaky start, Zeck’s a big-time corporate lawyer, Alex is a professor of medicine…God help us, but let’s talk about Mark here. What have you been up to all these years?”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Before Mark could wet his lips for a reply, Alex pounced, slipping into his ancient role as torturer of the geek. “Yeah, let’s hear it. Shackleton is probably some kind of dot-com billionaire with his own 737 and a basketball team. Did you go on to invent the cell phone or something like that? I mean ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("you were always writing stuff in that notebook of yours, always with the closed bedroom door. What were you doing in there, sport, besides going through back issues of Playboy and boxes of Kleenex?”")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Will and Zeckendorf couldn’t suppress a yuk because back then the kid always did seem to buy a whole lot of Kleenex. But straightaway Will felt a pang of guilt when Mark impaled him with a barbed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("et tu")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brute?")]), _vm._v(" kind of look.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I’m in computer security,” Mark half whispered into his plate. “Unfortunately, I’m not a billionaire.” He looked up and added hopefully, “I also do some writing on the side.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You work at a company?” Will asked politely, trying to redeem himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I worked for a few of them but now I’m like you, I guess. I work for the government.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Really. Where?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Nevada.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You live in Vegas, right?” Zeckendorf said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mark nodded, clearly disappointed no one had keyed onto his comment about writing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Which branch?” Will asked, and when his reply was a mute stare, he added, “Of the government?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mark’s angular Adam’s apple moved as he swallowed. “It’s a lab. It’s kind of classified.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Shack’s got a secret!” Alex shouted gleefully. “Give him another drink! Loosen his lips!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Zeckendorf looked fascinated. “Come on, Mark, can’t you tell us something about it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Alex leaned in. “I bet a certain someone from the FBI could find out what you’re up to.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I don’t think so,” Mark replied with a dram of smugness.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("Zeckendorf wouldn’t let it go and thought out loud, ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("“Nevada, Nevada—the only secret government lab I’ve ever heard of in Nevada is out in the desert…at what’s called…Area 51?” He waited for a denial but got a good long poker face instead. “Tell me you don’t work at Area 51!”")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Mark hesitated then said slyly, “I can’t tell you that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Wow,” the model said, impressed. “Isn’t that where they study UFOs and things like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mark smiled like the Mona Lisa, enigmatically.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“If he told you, he’d have to kill you,” Will said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mark vigorously shook his head, his eyes lowered and turning humorless. There was a reedy dryness in his throat that Will found disquieting. “No. If I told you, other people would kill you.”")])])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page15"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9495d9a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch02.vue
// module id = 69
// module chunks = 0